import { common } from '@ocean/ui'
import { Title } from './CardTitle.styled'

const { Typography } = common

export type CardTitleProps = {
  title: string
  rows?: number
}

const CardTitle: React.FC<CardTitleProps> = ({ title, rows }) => {
  return (
    <Title rows={rows}>
      <Typography variant='h3' dataTest='CardTitle'>
        {title}
      </Typography>
    </Title>
  )
}

export default CardTitle
